<template>
    <v-btn
        color="teal"
        dark
        absolute
        bottom
        right
        fab
        class="mb-5"
    >
        <v-icon>add</v-icon>
    </v-btn>
</template>


<script>
export default {
    data(){
        return{
            direction: 'top',
            fab: false,
            fling: false,
            hover: false,
            tabs: null,
            top: false,
            right: true,
            bottom: true,
            left: false,
            transition: 'slide-y-reverse-transition'
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/mensagens/layout/BotaoAcao.vue